import AsyncStorage from '@react-native-async-storage/async-storage';
import * as StoreReview from 'expo-store-review';

/** Bump the suffix to give everyone one more ask on a future release. */
const ASKED_KEY = 'review-prompt/asked-v1';

/**
 * Ask the OS to show its star-rating sheet, at most once per install.
 *
 * The flag is only written once `requestReview` resolves, so a throw leaves the
 * single ask intact for next time. Everything is swallowed — a review prompt is
 * never worth interrupting the game for.
 *
 * Callers should let the current screen transition finish first: the sheet is
 * presented on the topmost view controller, and presenting mid-transition gets
 * it silently dropped.
 */
export async function maybeRequestReview(): Promise<void> {
  try {
    if (await AsyncStorage.getItem(ASKED_KEY)) return;
    // False on web, in TestFlight, and below Android 5 — bail before burning
    // the one ask on a platform that can't show anything.
    if (!(await StoreReview.isAvailableAsync())) return;

    await StoreReview.requestReview();
    await AsyncStorage.setItem(ASKED_KEY, '1');
  } catch {
    // No review this run. Not worth surfacing.
  }
}
